import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DXSelectFilter from '../DXSelectFilter/DXSelectFilter';
import DXFilterConfig from '../DXFilterConfig';
import constants from '../../constants';

const propTypes = {
  equality: PropTypes.string,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selected: [],
};

class DXCustomerDefaultPaymentMethodFilter extends React.Component {
  render() {
    const { selected, onChange, intl, equality } = this.props;
    const config = DXCustomerDefaultPaymentMethodFilter.getConfig(intl, equality);
    return (
      <DXSelectFilter
        selected={selected}
        title={config.title}
        values={config.values}
        onChange={onChange}
        multi={config.multi}
      />
    );
  }
}

DXCustomerDefaultPaymentMethodFilter.propTypes = propTypes;
DXCustomerDefaultPaymentMethodFilter.defaultProps = defaultProps;
DXCustomerDefaultPaymentMethodFilter.getLabel = (intl, selectedValues) => {
  return DXSelectFilter.getLabel(intl, 'customer.filter.defaultPaymentMethod.', selectedValues);
};
DXCustomerDefaultPaymentMethodFilter.applyToQueryParams = (queryParams, selectedValues) => {
  selectedValues[0] && (queryParams['hasDefaultPaymentMethod'] = selectedValues[0]);
  return queryParams;
};
DXCustomerDefaultPaymentMethodFilter.getConfig = (intl, equality) => {
  let config = new DXFilterConfig({
    name: 'hasDefaultPaymentMethod',
    selected: [],
    property: 'hasDefaultPaymentMethod',
    title: intl.formatMessage({ id: 'customer.filter.defaultPaymentMethod' }),
    disabled: false,
    equalityStatus: false,
    multi: false,
  });

  if (equality === constants.FILTER_EQUALITY_EQUALS) {
    config.addFilterValue('true', intl.formatMessage({ id: 'customer.filter.defaultPaymentMethod.true' }));
    config.addFilterValue('false', intl.formatMessage({ id: 'customer.filter.defaultPaymentMethod.false' }));
  }

  return config;
};

export default injectIntl(DXCustomerDefaultPaymentMethodFilter);
